import { render, staticRenderFns } from "./SectionParticipantSettings.vue?vue&type=template&id=4da3f654&"
import script from "./SectionParticipantSettings.vue?vue&type=script&lang=js&"
export * from "./SectionParticipantSettings.vue?vue&type=script&lang=js&"
import style0 from "./SectionParticipantSettings.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports